import { Icon } from './types';

export const GrowthChart = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 34 34"
    fill="none"
    data-testid="growth-chart"
    {...svgProps}
  >
    <path
      fill="currentColor"
      d="M4.25 29.75v-2.833l2.833-2.834v5.667H4.25Zm5.667 0v-8.5l2.833-2.833V29.75H9.917Zm5.666 0V18.417l2.834 2.875v8.472h-2.834v-.014Zm5.667 0v-8.472l2.833-2.833V29.75H21.25Zm5.667 0V15.583l2.833-2.833v17h-2.833ZM4.25 22.426v-4.01L14.167 8.5l5.666 5.667L29.75 4.25v4.01l-9.917 9.916-5.666-5.667-9.917 9.917Z"
      {...pathProps}
    />
  </svg>
);
